import TSRules from "./controller";

export default {
    __init__: ['tsRules'],
    tsRules: ['type', TSRules]
};